import { useCanonical } from '../utilities/useCanonical';

const CanonicalTag: React.FC = () => {
  useCanonical();
  return null;
};

export default CanonicalTag;
